import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import {advancedSearchItemsCleared} from '../reducer';

export const useClearAdvancedSearchItems = () => {
  const dispatch = useAppDispatch();
  return useCallback(() => {
    dispatch(advancedSearchItemsCleared());
  }, [dispatch]);
};
